import { type ThemeOptions, darken, lighten } from '@mui/material'

import components from '~/theme/components'
import { charting, day, kindaBlue, miamiViceDay, miamiViceNight, night } from '~/theme/palettes'
import type { PaletteThemeId } from '~/theme/themePreference'
import typography from '~/theme/typography'

const paletteFor = (themeId: PaletteThemeId) => {
  switch (themeId) {
    case 'light':
      return day
    case 'kindaBlue':
      return kindaBlue
    case 'miamiViceDay':
      return miamiViceDay
    case 'miamiViceNight':
      return miamiViceNight
    case 'dark':
      return night
    default: {
      const exhaustive: never = themeId
      return exhaustive
    }
  }
}

/** Themes whose identity is their own accent, so the org accent color does not apply. */
const ownsAccent = (themeId: PaletteThemeId) => themeId === 'miamiViceDay' || themeId === 'miamiViceNight'

const UserThemeOptions = (themeId: PaletteThemeId, accentColor?: string): ThemeOptions => {
  const palette = paletteFor(themeId)
  return {
    palette: {
      ...palette,
      charting,
      accent:
        accentColor && !ownsAccent(themeId)
          ? {
              main: accentColor,
              dark: darken(accentColor, 0.2),
              light: lighten(accentColor, 0.2)
            }
          : palette.primary
    },

    typography,
    components
  }
}

export default UserThemeOptions
